import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, api, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic212 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [fromData, setFromData] = useState({
    stakeholderEngagement: "",
    stakeholderFeedbackInDecisionMaking: {
      engagement: "",
      feedback: "",
    },
    governanceBodyEffectivenessReview: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        setFromData({
          stakeholderEngagement:
            res.data.data.GeneralDisclosures2021.governanceBodyRoleInStrategy
              .stakeholderEngagement,

          stakeholderFeedbackInDecisionMaking: {
            engagement:
              res.data.data.GeneralDisclosures2021.governanceBodyRoleInStrategy
                .stakeholderFeedbackInDecisionMaking.engagement,

            feedback:
              res.data.data.GeneralDisclosures2021.governanceBodyRoleInStrategy
                .stakeholderFeedbackInDecisionMaking.feedback,
          },

          governanceBodyEffectivenessReview:
            res.data.data.GeneralDisclosures2021.governanceBodyRoleInStrategy
              .governanceBodyEffectivenessReview,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    if (!disabled) {
      // const validationErrors = validateFields();

      // If there are errors, prevent form submission
      // if (Object.keys(validationErrors).length > 0) {
      //   console.log("Form contains errors", fromData, validationErrors);
      //   return;
      // }
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`${api}/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          governanceBodyRoleInStrategy: { ...fromData },
          submitted2_12: true,
        })
          .then((res) => {
            console.log(res, "success response");
            navigate(`/gri/general-disclosure/2-13/${id}`);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-13/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Describe the role of the highest governance body and of senior executives in developing, approving, and updating the organization’s purpose, value or mission statements, strategies, policies, and goals related to sustainable development",
      fieldName: "stakeholderEngagement",
    },

    {
      index: "b.",
      heading:
        "Describe the role of the highest governance body in overseeing the organization's due diligence and other processes to identify and manage the organization's impacts on the economy, environment, and people .",
      subfieldName: "stakeholderFeedbackInDecisionMaking",
      fields: [
        {
          index: "i.",
          subheading:
            "Describe how the highest governance body engages with stakeholders to support these processes .",
          fieldName: "engagement",
        },
        {
          index: "ii.",
          subheading:
            "Describe how the highest governance body consider the outcomes and feedback gathered from stakeholder engagement in its decision-making regarding sustainability impacts.",
          fieldName: "feedback",
        },
      ],
    },
    {
      index: "c.",
      heading:
        "Describe how does the highest governance body reviews the effectiveness of the organization's processes for managing its sustainability impacts as described previously and what specific aspects of these processes are reviewed (e.g., risk identification, mitigation strategies, performance monitoring).",
      fieldName: "governanceBodyEffectivenessReview",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-12 Role of the highest governance body in overseeing the management of impacts"
        {...{
          inputData,
          fromData,
          setFromData,
          setErrors,
          disabled: disabled,
          errors,
          hide
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic212;
